import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import _ from 'lodash';
import compose from 'lodash/fp/compose';
import { WAGE_LEDGER_CSV } from 'src/constants/EndpointUrls';
import { redirectTo, serializeHttpGetParams } from 'src/utils/Http';
import DownloadCsvInsideForm from '../components/DownloadCsvInsideForm';

const downloadCsv = (data, downloadParams) => {
  const encoding = _.get(data, 'encoding');
  redirectTo(`${WAGE_LEDGER_CSV}?${serializeHttpGetParams({ ...downloadParams, encoding })}`);
};

function mapDispatchToProps(dispatch, ownProps) {
  return {
    onSubmit: data => {
      downloadCsv(data, ownProps.downloadParams);
      ownProps.cancelBtnClick();
    }
  };
}

export default compose(
  connect(null, mapDispatchToProps),
  reduxForm({
    form: 'DownloadCsvInsideForm',
    initialValues: { encoding: 'UTF-8' }
  })
)(DownloadCsvInsideForm);
